// src/platform/site/types.ts
var PlatformSiteAriResourceOwner = "platform", PlatformSiteAriResourceType = "site";

export {
  PlatformSiteAriResourceOwner,
  PlatformSiteAriResourceType
};
